import { ReactNode, SVGAttributes } from 'react';

import clsx from 'clsx';

export function GenIcon(element: JSX.Element) {
  return (props: IconBaseProps) => (
    <IconBase attr={{ ...element.props }} {...props}>
      {element.props?.children}
    </IconBase>
  );
}

export interface IconBaseProps extends SVGAttributes<SVGElement> {
  children?: ReactNode;
  size?: string | number;
  color?: string;
  title?: string;
}

export type IconType = (props: IconBaseProps) => JSX.Element;
export function IconBase(props: IconBaseProps & { attr?: Record<string, string> }): JSX.Element {
  const elem = () => {
    const { attr, size, title, ...svgProps } = props;
    const computedSize = size || '1em';

    return (
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        {...attr}
        {...svgProps}
        className={clsx(svgProps.className, props.className)}
        style={{ ...svgProps.style, color: props.color, ...props.style }}
        height={computedSize}
        width={computedSize}
        xmlns="http://www.w3.org/2000/svg"
      >
        {title && <title>{title}</title>}
        {props.children}
      </svg>
    );
  };

  return elem();
}
